/**
 * INTACT — reveal au scroll
 * Un seul IntersectionObserver partagé pour tous les éléments `.reveal`.
 * Le stagger entre enfants d'un même groupe se fait en CSS via --reveal-index,
 * posé ici en JS au moment où l'élément entre dans le DOM observé.
 */
(function () {
  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  var root = document.documentElement;
  var animationsEnabled = root.getAttribute("data-animations-enabled") !== "false";

  function markStaggerIndices() {
    document.querySelectorAll("[data-reveal-group]").forEach(function (group) {
      var items = group.querySelectorAll(".reveal");
      items.forEach(function (el, index) {
        el.style.setProperty("--reveal-index", index);
      });
    });
  }

  if (prefersReducedMotion || !animationsEnabled) {
    document.querySelectorAll(".reveal").forEach(function (el) {
      el.classList.add("reveal--visible");
    });
    return;
  }

  markStaggerIndices();

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal--visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.15,
    }
  );

  document.querySelectorAll(".reveal").forEach(function (el) {
    observer.observe(el);
  });

  // La frise savoir-faire dessine son trait de liaison en fonction
  // de la progression de scroll dans la section, indépendamment du reveal.
  var processSection = document.querySelector("[data-process-line]");
  if (processSection) {
    var line = processSection.querySelector(".process__line-fill");
    var onScroll = function () {
      var rect = processSection.getBoundingClientRect();
      var viewportH = window.innerHeight;
      var progress = (viewportH - rect.top) / (rect.height + viewportH * 0.4);
      progress = Math.max(0, Math.min(1, progress));
      if (line) {
        line.style.transform = "scaleX(" + progress + ")";
      }
    };
    document.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // Re-calcule les index de stagger si le theme editor recharge une section
  document.addEventListener("shopify:section:load", function () {
    markStaggerIndices();
    document.querySelectorAll(".reveal:not(.reveal--visible)").forEach(function (el) {
      observer.observe(el);
    });
  });
})();
